import { useMutation } from "@apollo/client"

import { graphql } from "./generated/gql"
import { AddPersonInput } from "./generated/graphql"
import { GET_ALL_PEOPLE } from "./get-all-people"

export const useAddPerson = () => {
  const [mutation, { data, loading, error }] = useMutation(ADD_PERSON, {
    update(cache, { data }) {
      if (!data?.addPerson) return
      const query = cache.readQuery({ query: GET_ALL_PEOPLE })
      // If cache is empty, don't try and populate it with just our object
      if (!query || !query?.people) return
      cache.writeQuery({
        query: GET_ALL_PEOPLE,
        data: { people: [...query.people, data.addPerson] },
      })
    },
  })

  const addPerson = async (person: AddPersonInput) =>
    await mutation({ variables: { person } })

  const addedPersonId = data?.addPerson?.id

  return { addPerson, addedPersonId, loading, error }
}

export const ADD_PERSON = graphql(`
  mutation AddPerson($person: AddPersonInput!) {
    addPerson(person: $person) {
      ...PersonFragment
      spouses {
        id
        type
      }
      siblings {
        id
        type
      }
      parents {
        id
        type
      }
      children {
        id
        type
      }
    }
  }
`)
